<template>
  <div class="max-width" v-html="$t('contactService.contact.categories.premium_partner.content')"></div>
</template>

<style>
.max-width{
  max-width: 800px;
}
</style>
